import axios from 'axios';
import { MainpageFiltersType } from '../pages/Mainpage/types';
import { TextbookSearchType } from '../pages/TextbooksPage/types';
import { generateTextbookXlsQueries } from './types';

export const api = axios.create({
  baseURL: '/',
});

export const upload = axios.create({
  baseURL: '/',
});

upload.interceptors.request.use(function (config) {
  const token = localStorage.getItem('userToken') || '';
  config.headers = {};
  config.headers['Content-Type'] = 'application/json';
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

api.interceptors.request.use(function (config) {
  const token = localStorage.getItem('userToken') || '';
  config.headers = config.headers || {};
  if (!config.headers['Content-Type']) config.headers['Content-Type'] = 'application/json';

  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

export const endpoints = {
  login: (): string => '/api/login',
  createUser: (): string => '/private/api/v1/user',
  changeUserPass: (id: number | string) => `/private/api/v1/user/change-pass/${id}`,
  acceptExpertiseListById: (id: number): string => `/private/api/v1/expertise-list/${id}/accept`,
  getExpertiseListPdfById: (id: number): string => `/private/api/v1/expertise-list/pdf/${id}`,
  loadFinalList: (id: number): string => `/private/api/v1/expertise-list/${id}/load-final-list`,
  rejectExpertiseListById: (id: number): string => `/private/api/v1/expertise-list/${id}/reject`,
  getUserById: (id: number | string): string => `/private/api/v1/user/${id}`,
  confirmRepresentativeEmail: (token: string): string => `api/email-confirmation/${token}`,
  getCurrentRepresentativeExpertises: (): string =>
    '/private/api/v1/representative/current/expertises?page=0&perPage=10000',
  sendExpertiseListToFo: (id: number | string): string => `/private/api/v1/expertise-list/${id}/send-to-fo`,
  updateExpert: (id: number | string): string => `/private/api/v1/expert/${id}`,
  selfUpdateExpert: (): string => '/private/api/v1/expert/self/update',
  getUsersByRole: (role: string, fio?: string) => `/private/api/v1/user?role=${role}${fio ? `&fio=${fio}` : ''}`,
  getTextbookId: (id: number | string): string => `/private/api/v1/textbook/${id}`,
  getPublicEducationLevels: (): string => '/public/api/v1/education-levels',
  getExpertsXls: (): string => '/private/api/v1/expert/experts-xls',
  getExpertiseListsXls: ({ ...props }: TextbookSearchType): string =>
    `/private/api/v1/expert/expertise-lists-xls?${props.status ? `&status=${props.status}` : ''}
    ${props.status ? `&status=${props.status}` : ''}
    ${props.name ? `&name=${props.name}` : ''}
    ${props.publisher ? `&publisher=${props.publisher}` : ''}
    ${props.author ? `&author=${props.author}` : ''}
    ${props.school_classes ? `&school_class=${props.school_classes}` : ''}
    ${props.year ? `&year=${props.year}` : ''}`,
  getPovs: ({ region, page }: { region?: number; page?: number }): string =>
    `/private/api/v1/expert/povs?perPage=10${page ? `&page=${page}` : ''}${region ? `&region=${region}` : ''}`,
  getCurrentRepresentativeExpertisesWithFilters: ({
    status,
    date_application_from,
    date_application_to,
    date_registration_from,
    date_registration_to,
  }: {
    status?: number;
    date_application_from?: string;
    date_application_to?: string;
    date_registration_from?: string;
    date_registration_to?: string;
  }): string =>
    `/private/api/v1/representative/current/expertises?page=0&perPage=10000
    ${status ? `&status=${status}` : ''}
    ${date_application_from ? `&date_application_from=${date_application_from}` : ''}
    ${date_application_to ? `&date_application_to=${date_application_to}` : ''}
    ${date_registration_from ? `&date_registration_from=${date_registration_from}` : ''}
    ${date_registration_to ? `&date_registration_to=${date_registration_to}` : ''}`,
  getCurrentExpertExpertises: (): string => '/private/api/v1/expert/current/expertises',
  getNmsTextbooksById: ({
    id,
    title,
    publisher,
    author,
    school_classes,
  }: {
    id: number | string;
    title?: string;
    publisher?: string;
    author?: string;
    school_classes?: string | number;
  }): string =>
    `/private/api/v1/nms/${id}/textbooks?perPage=1000${title ? `&title=${title}` : ''}${
      publisher ? `&publisher=${publisher}` : ''
    }${author ? `&author=${author}` : ''}${school_classes ? `&school_classes=${school_classes}` : ''}`,
  getSubjectAreas: (): string => '/private/api/v1/lists/subject-area',
  getSubjects: (): string => '/private/api/v1/lists/subjects',
  getPublicSubjects: (): string => '/public/api/v1/subjects',
  getLanguages: (): string => '/private/api/v1/lists/languages',
  putExpert: (id: number | string): string => `/private/api/v1/expert/${id}`,
  putUser: (id: number | string): string => `/private/api/v1/user/${id}`,
  getSchoolClasses: (): string => '/private/api/v1/lists/school-classes',
  postNms: (): string => '/private/api/v1/nms',
  getNms: (): string => '/private/api/v1/nms?perPage=1000',
  getTextbooksXls: (props: MainpageFiltersType): string =>
    `/public/api/v1/textbooks-xls${generateTextbookXlsQueries(props)}`,
  registerApplication: (id: number | string): string => `/private/api/v1/application/${id}/register`,
  getNmsByFilters: (year: number | string): string => `/private/api/v1/nms?perPage=1000&date=${year}`,
  getNmsById: (id: number | string): string => `/private/api/v1/nms/${id}`,
  getPublicSchoolClasses: (): string => '/public/api/v1/school-classes',
  getPublicAuthors: (): string => '/public/api/v1/authors',
  getPublicSubjectLists: (): string => '/public/api/v1/subjects-all',
  sendFile: (): string => '/private/api/v1/file',
  getPublicDocuments: (): string => '/public/api/v1/document-categories',
  getPublicDocumentById: (id: number | string): string => `/public/api/v1/document-category/${id}`,
  newApplication: (): string => '/private/api/v1/application',
  getPublicSubjectsBySubjectArea: (subjectArea: string): string =>
    `/public/api/v1/subjects-by-area?subject_area=${subjectArea}`,
  getPublishers: (page: number, perPage: number): string => `/private/api/v1/publisher?page=${page}&perPage=${perPage}`,

  getPublicPublishers: (page: number, perPage: number): string =>
    `/public/api/v1/publishers?page=${page}&perPage=${perPage}`,
  getApplications: (page: number, perPage: number, name?: string): string =>
    `/private/api/v1/application?perPage=${perPage}${`&page=${page}`}&${name ? `&name=${name}` : ''}`,
  getPublisherById: (id: number | string): string => `/private/api/v1/publisher/${id}`,
  getExpertById: (id: number | string): string => `/private/api/v1/expert/${id}`,
  getApplicationById: (id: string): string => `/private/api/v1/application/${id}`,
  getAcademicDegrees: (): string => '/private/api/v1/lists/academic-degrees',
  getFile: (filePath: string | number): string => `/private/api/v1/file/${filePath}`,
  deleteFile: (id: number | string): string => `/private/api/v1/file/${id}`,
  getStatuses: (): string => '/private/api/v1/application/status',
  getExpertiseListStatus: (): string => '/private/api/v1/lists/expertise-list-status',
  getPublicSubjectAreas: (): string => '/public/api/v1/subject-areas',
  getTextbookStatuses: (): string => '/private/api/v1/lists/textbook-status',
  getPublicTextbooks: ({
    perPage,
    page,
    subject_general,
    school_class,
    author,
    title,
    publisher,
    subject_area,
    fpu_group,
    education_level,
    language,
    level,
    adaptive,
    subject_all,
  }: {
    perPage: number;
    page: number;
    subject_general?: number;
    school_class?: number;
    author?: string;
    title?: string;
    publisher?: number;
    subject_area?: number;
    fpu_group?: string;
    education_level?: number;
    language?: number;
    level?: number;
    adaptive?: number;
    subject_all?: number;
  }): string =>
    `/public/api/v1/textbooks?perPage=${perPage}&page=${page}${
      subject_general ? `&subject_general=${subject_general}` : ''
    }${school_class ? `&school_class=${school_class}` : ''}${title ? `&title=${title}` : ''}${
      publisher ? `&publisher=${publisher}` : ''
    }${subject_area ? `&subject_area=${subject_area}` : ''}${fpu_group ? `&fpu_group=${fpu_group}` : ''}${
      author ? `&author=${author}` : ''
    }${education_level ? `&education_level=${education_level}` : ''}${language ? `&language=${language}` : ''}${
      level ? `&level=${level}` : ''
    }${adaptive ? `&adaptive=${adaptive}` : ''}${subject_all ? `&subject_all=${subject_all}` : ''}`,
  getApplicationByParams: ({
    publisherId,
    status,
    fio,
    year,
    application_at,
    application_to,
    perPage,
    page,
  }: {
    publisherId?: number;
    status?: number;
    fio?: string;
    year?: number;
    application_at?: string;
    application_to?: string;
    perPage: number | string;
    page?: number | string;
  }): string =>
    `/private/api/v1/application?perPage=${perPage}${publisherId ? `&publisher=${publisherId}` : ''}${
      status ? `&status=${status}` : ''
    }${fio ? `&fio=${fio}` : ''}${year ? `&year=${year}` : ''}${
      application_at ? `&date_application_from=${application_at}` : ''
    }${application_to ? `&date_application_to=${application_to}` : ''}${page ? `&page=${page}` : ''}`,
  registerRepresentative: (): string => '/public/api/v1/register-representative',
  addPublicFile: (): string => '/public/api/v1/file',
  getNmsTextbookTitles: (id: number | string) => `/private/api/v1/nms/${id}/textbook-titles`,
  getNmsTextbookPublishers: (id: number | string) => `/private/api/v1/nms/${id}/textbook-publishers`,
  getNmsTextbookAuthors: (id: number | string) => `/private/api/v1/nms/${id}/textbook-authors`,
  getNmsTextbookSchoolClasses: (id: number | string) => `/private/api/v1/nms/${id}/textbook-school-classes`,
  postBigFile: () => 'private/api/v1/big-file',
  getExperts: ({
    perPage,
    page,
    subject,
    subject_area,
    fio,
    status,
  }: {
    perPage?: number;
    page?: number;
    subject?: number;
    subject_area?: number;
    status?: number;
    fio?: string;
  }): string =>
    `/private/api/v1/expert?perPage=${perPage ? perPage : 0}&expert=1${page && page > 0 ? `&page=${page}` : ''}${
      subject ? `&subject_general=${subject}` : ''
    }${subject_area ? `&subject_area_general=${subject_area}` : ''}${fio ? `&fio=${fio}` : ''}${
      status ? `&status=${status}` : ''
    }`,
  getRegions: (): string => '/private/api/v1/lists/regions',
  expertiseAddExpert: (id: number | string): string => `/private/api/v1/expertise/experts-add/${id}`,
  updateExpertiseExpert: (id: number | string): string => `/private/api/v1/expertise/${id}/accept`,
  expertiseAddDate: (id: number | string): string => `/private/api/v1/expertise/${id}/add-date`,
  expertiseChangeDate: (id: number | string): string => `/private/api/v1/expertise/change-date-send-notification/${id}`,
  expertiseChangeCreatedAt: (id: number | string): string => `/private/api/v1/expertise/change-date-created-at/${id}`,
  expertiseChangeExpert: (expertiseId: number | string, expertId: number | string): string =>
    `/private/api/v1/expertise/expert-change/${expertiseId}/${expertId}`,
  getTextbookById: (id: number | string): string => `/private/api/v1/textbook/${id}`,
  getTextbooks: ({
    page,
    perPage,
    name,
    publisher,
    status,
    author,
    school_classes,
    year,
    date,
  }: {
    page?: number;
    perPage?: number;
    name?: string;
    publisher?: number;
    status?: number;
    author?: string;
    school_classes?: number;
    year?: number | string;
    date?: string;
  }): string => `/private/api/v1/textbook?perPage=${perPage ? perPage : 0}${page && page > 0 ? `&page=${page}` : ''}
  ${name ? `&title=${name}` : ''}
  ${publisher ? `&publisher=${publisher}` : ''}
  ${status ? `&status=${status}` : ''}
  ${author ? `&author=${author}` : ''}
  ${school_classes ? `&school_class=${school_classes}` : ''}
  ${year ? `&year=${year}` : ''}
  ${date ? `&date=${date}` : ''}
  `,
  getPovsExpertises: ({
    page,
    perPage = 10,
    publisher,
    author,
    name,
    year,
    school_class,
    status,
    subject_area,
    fio,
  }: {
    page?: number;
    perPage: number;
    name?: string;
    fio?: string;
    subject_area?: number;
    title?: string;
    school_class?: number;
    author?: string;
    publisher?: number;
    status?: number;
    year?: number;
  }): string =>
    `/private/api/v1/expertise?perPage=${perPage}${page && page > 0 ? `&page=${page - 1}` : '&page=0'}&povs=1
    ${publisher ? `&publisher=${publisher}` : ''}${author ? `&author=${author}` : ''}${name ? `&name=${name}` : ''}
    ${year ? `&year=${year}` : ''}
    ${school_class ? `&school_class=${school_class}` : ''}
    ${status ? `&expertise_list_status=${status}` : ''}
    ${subject_area ? `&subjectGeneral=${subject_area}` : ''}
    ${fio ? `&fio=${fio}` : ''}`,
  getExpertises: ({
    page,
    perPage,
    publisher,
    author,
    name,
    year,
    school_class,
    status,
    subject_area,
    fio,
  }: {
    page?: number;
    perPage?: number;
    name?: string;
    fio?: string;
    subject_area?: number;
    title?: string;
    school_class?: number;
    author?: string;
    publisher?: number;
    status?: number | string;
    year?: number;
  }): string =>
    `/private/api/v1/expertise?perPage=${perPage ? perPage : 0}${publisher ? `&publisher=${publisher}` : ''}&expert=1${
      author ? `&author=${author}` : ''
    }${name ? `&name=${name}` : ''}
    ${year ? `&year=${year}` : ''}
    ${school_class ? `&school_class=${school_class}` : ''}
    ${status ? `&expertise_list_status=${status}` : ''}
    ${subject_area ? `&subjectGeneral=${subject_area}` : ''}
    ${fio ? `&fio=${fio}` : ''}
    ${page && page > 0 ? `&page=${page}` : ''}`,
  getExpertiseTextbooks: ({
    page,
    perPage,
    publisher,
    author,
    name,
    year,
    school_class,
    status,
  }: {
    page?: number;
    perPage?: number;
    publisher?: number | string;
    author?: string;
    name?: string;
    year?: string;
    school_class?: number;
    status?: number | string;
  }): string =>
    `/private/api/v1/expertise/textbooks?perPage=${perPage ? perPage : 0}${publisher ? `&publisher=${publisher}` : ''}${
      author ? `&author=${author}` : ''
    }${name ? `&name=${name}` : ''}${year ? `&year=${year}` : ''}${
      school_class ? `&school_class=${school_class}` : ''
    }${status ? `&status=${status}` : ''}${page && page > 0 ? `&page=${page}` : ''}`,
  getExpertiseStatuses: (): string => '/private/api/v1/lists/expertise-status',
  getExpertStatuses: (): string => '/private/api/v1/lists/expert-status',
  createExpertiseList: (): string => '/private/api/v1/expertise-list',
  getExpertiseListById: (id: string | number): string => `/private/api/v1/expertise-list/${id}`,
  getRepresentativeById: (id: number | string) => `/private/api/v1/representative/${id}`,
  getRepresentatives: ({
    page,
    perPage,
    last_name,
    first_name,
    patronymic,
    publisher,
    status,
  }: {
    page: number;
    perPage: number;
    last_name?: string;
    first_name?: string;
    patronymic?: string;
    publisher?: number;
    status?: number;
  }): string =>
    `/private/api/v1/representative?perPage=${perPage}
    ${page && page > 0 ? `&page=${page}` : '&page=0'}
    ${last_name ? `&last_name=${last_name}` : ''}
    ${first_name ? `&first_name=${first_name}` : ''}
    ${patronymic ? `&patronymic=${patronymic}` : ''}
    ${publisher ? `&publisher=${publisher}` : ''}
    ${status ? `&status=${status}` : ''}`,
  representativeUpdate: ({ id }: { id: number }): string => `/private/api/v1/representative/${id}`,
  representativeStatus: (): string => '/private/api/v1/lists/representative-status',
  expertiseStatus: (): string => '/private/api/v1/lists/expertise-status',
  getApplicationStatuses: (): string => '/private/api/v1/application/status',
  addFile: (): string => '/private/api/v1/file',
  getFileBySlug: (slug: string): string => `/public/api/v1/file-by-slug/${slug}`,
  getScienceBranches: (): string => '/private/api/v1/lists/branches-of-science',
  getDocumentCategories: (): string => 'private/api/v1/document-category',
  getDocumentCategoryById: (id: string): string => `private/api/v1/document-category/${id}`,
  getDocumentById: (id: string | number): string => `/private/api/v1/document/${id}`,
  postDocumentCategory: (): string => '/private/api/v1/document-category',
  putTextbook: (id: number | string): string => `/private/api/v1/textbook/${id}`,
  postDocument: (): string => '/private/api/v1/document',
  deleteDocumentById: ({ id }: { id: number | string }): string => `/private/api/v1/document-category/${id}`,
  deleteDocumentId: ({ id }: { id: number | string }): string => `/private/api/v1/document/${id}`,
  getScientificTitles: (): string => '/private/api/v1/lists/scientific-titles',
  getSpecialties: (): string => '/private/api/v1/lists/specialties',
  addDocumentFile: (): string => '/private/api/v1/document-file',
  changeDocumentFile: (id: number | string): string => `/private/api/v1/document-file/${id}`,
  deleteDocumentFileId: (id: number | string): string => `/private/api/v1/document-file/${id}`,
  postPublisher: (): string => '/private/api/v1/publisher',
  putPublisherById: (id: string | number): string => `/private/api/v1/publisher/${id}`,
  getTextbookLevels: (): string => '/private/api/v1/lists/textbook-levels',
  getPublicTextbookLevels: (): string => '/public/api/v1/education-levels',
  getPublicLanguages: (): string => '/public/api/v1/languages',
  getExpertiseByExpert: (expertId: number | string): string => `/private/api/v1/expertise/by-expert/${expertId}`,
  getExpertiseById: (id: number | string): string => `/private/api/v1/expertise/${id}`,
  postExpert: (): string => '/private/api/v1/expert',
  postPovs: (): string => '/private/api/v1/expert/povs/add',
  putExpertiseList: (id: string | number) => `/private/api/v1/expertise-list/${id}`,
  getUserData: (): string => '/private/api/v1/user/current/data',
  getCurrentUserExpertises: (): string => '/private/api/v1/representative/current/expertises',
};
